import { useAuth0 } from "@auth0/auth0-react";
import AuthService from 'Lib/API/Auth';
import React, { useContext, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import UserContext from "../NewChargeContext";
import Account from "./BatchChargeType/Account";
import Manual from "./BatchChargeType/Manual";
import PreviousAmount from "./BatchChargeType/PreviousAmount";
import File from "./BatchChargeType/File"
const types = ["Manual", "Account", "Previous Amount", "File"];

const BatchChargeDetails = ({ ...props }) => {
  const { getAccessTokenSilently } = useAuth0();
  const orgDetails = getOrganizationInfoFromLocalStorage();


  const formik = props;
  const { editData, setRowData } = useContext(UserContext);
  const batchType =
    formik?.values?.batch_type === "manual"
      ? "Manual"
      : formik?.values?.batch_type === "account"
        ? "Account"
        : formik?.values?.batch_type === "previous_amount" ||
          formik?.values?.batch_type === "previous_amounts"
          ? "Previous Amount"
          : "File";






  const [show, setShow] = useState(batchType);
  const renderComponent = () => {
    switch (show) {
      case "Manual":
        return (
          <Manual
            types={types}
            setShow={setShow}
            show={show}
            formik={formik}
            // index={index}
            enableInstallments={orgDetails?.allowInstallments}
          />
        );
      case "Account":
        return (
          <Account
            types={types}
            setShow={setShow}
            show={show}
            formik={formik}
            // index={index}
            enableInstallments={orgDetails?.allowInstallments}
          />
        );
      case "Previous Amount":
        return (
          <PreviousAmount
            types={types}
            setShow={setShow}
            show={show}
            formik={formik}
            // index={index}
            enableInstallments={orgDetails?.allowInstallments}
          />
        );
      case "File":
        return (
          <File
            types={types}
            setShow={setShow}
            show={show}
            formik={formik}
            // index={index}
            enableInstallments={orgDetails?.allowInstallments}
          />
        );
      default:
        return <>Loading...</>;
    }
  };
  return (
    <div className="">
      <p>{renderComponent()}</p>
    </div>
  );
};

export default BatchChargeDetails;
